export default {"src":"/_next/static/image/public/images/flags/flag_234.2521d349f92bcc4e39fc806df4c8f875.svg","height":16,"width":24};